class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetails = this.querySelector('details');
    this.allDesktopNavDetails = document.querySelectorAll('.header__desktop-nav details');
    this.menuDetailsItems = this.querySelector('[details-items]');

    this.addEventListener('keyup', this.onKeyUp);

    if(this.hasAttribute('on-hover')) {
      this.mainDetails.addEventListener('mouseenter', this.mouseenter.bind(this));
      this.menuDetailsItems.addEventListener('mouseleave', this.mouseleave.bind(this));
    } else {
      this.mainDetails.addEventListener('toggle', this.toggle.bind(this));
      this.mainDetails.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  mouseenter() {
    // first close all opened details
    this.allDesktopNavDetails.forEach((e) => {
      e.removeAttribute('open');
      e.setAttribute('closed', '');
    });

    this.mainDetails.setAttribute('open', '');
    
    if(this.mainDetails.hasAttribute('closed')) {
      this.mainDetails.removeAttribute('closed');
    }
  }

  mouseleave() {
    this.mainDetails.setAttribute('closed', '');

    if(this.mainDetails.hasAttribute('open')) {
      this.mainDetails.removeAttribute('open');
    }
  }
  
  toggle() {
    if(this.mainDetails.hasAttribute('open')) {
      this.mainDetails.removeAttribute('closed');
    }
    else{
      this.mainDetails.setAttribute('closed', '');
    }
  }

  close() {
    this.mainDetails.removeAttribute('open');
  }
}

try {
  customElements.define('details-disclosure', DetailsDisclosure);
}
catch(e) {
  console.log("details-disclosure already defined", e)
}


class DetailsSummaryLink extends HTMLElement {
  constructor() {
    super();

    this.summaryLink = this.querySelector('a');

    if(this.summaryLink) {
      this.summaryLink.addEventListener('click', this.openLink.bind(this));
    }
  }

  openLink(event) {
    const currentDetail = this.closest('details');
    if(!currentDetail.hasAttribute('open')) {
      event.preventDefault();
      currentDetail.setAttribute('open', '');
    }
  }
}

try {
  customElements.define('summary-link', DetailsSummaryLink);
}
catch(e) {
  console.log("summary-link already defined", e)
}